import React, { useEffect, useState } from "react";
import formLogo from "../../../Asset/Img/Form-logo.svg";
import { useNavigate } from "react-router-dom";
import Layout from "../../Layout/Layout";
import {
  getLocationApi,
  visitorTypeApi,
  organizationApi,
  roleData,
  checkInRefuse,
  MasterLabelAPI,
  FieldTableAPI,
  checkOutList,
  OrganizationFeaturesList,
  CSOAPI,
} from "../../apis/apisServies";
import { useDispatch, useSelector } from "react-redux";
import { selectToken } from "../../Store/actions/auth/authSelectors";
import { setVisitorArray } from "../../Store/actions/visitorType/visitorTypeReducer";
import { useNotification } from "../../NotificationProvider/NotificationProvider";
import { setlocationArray } from "../../Store/actions/locationData/locationReducer";
import "./css/style.css";
import {
  findDisplayName,
  isBatchView,
  isCreate,
  isNonEmptyString,
  isView,
} from "../../../utils/commonFunctionsAndStatices";
import { setFeaturesList, setOrganizationData } from "../../Store/actions/getorganization/organizationReducer";
import { setRoleData } from "../../Store/actions/role/roleReducer";
import { setMasterLabel } from "../../Store/actions/masterLabel/masterLabelReducer";
import { setFieldData } from "../../Store/actions/FieldTableData/FieldTableReducer";
import { setUserDatails } from "../../Store/actions/checkoutSearch/CheckoutScreenReducer";
import { languageid } from "../../Store/actions/languageId/selectLanguageId";
import { FaCirclePlay } from "react-icons/fa6";
import { setVisitorId } from "../../Store/actions/visitorId/visitorIdReducer";
import { setCSOData } from "../../Store/actions/csoReport/csoReportReducer";

export const CheckInPage = () => {
  const navigate = useNavigate();
  const loginData = useSelector(selectToken);
  const dispatch = useDispatch();
  const { showSuccess, showError } = useNotification();
  const [isLoading, setIsLoading] = useState(true);
  const labelLanguageID = useSelector(languageid);

  // * api call for get visitorType
  const getVistiorTypeHandler = async () => {
    const dataObj = {
      organizationid: loginData?.organization_id,
    };

    const response = await visitorTypeApi(dataObj);
    try {
      if (response.data.statusCode === 200) {
        dispatch(setVisitorArray(response?.data?.body));
      }
    } catch (error) {
      showError(error?.response?.data?.body?.message);
    }
  };
  // * api call for get location
  const getLocationHandler = async () => {
    const dataObj = {
      userid: loginData?.login_id,
    };

    const response = await getLocationApi(dataObj);
    try {
      if (response.data.statusCode === 200) {
        dispatch(setlocationArray(response?.data?.body));
      }
    } catch (error) {
      showError(error?.response?.data?.body?.message);
    }
  };

  const fetchOrganizationData = async () => {
    const dataObj = {
      organizationid: loginData.organization_id,
    };
    try {
      const response = await organizationApi(dataObj);
      const organizationData = response.data.body;
      dispatch(setOrganizationData(organizationData));
      const videoLink = response.data.body.video_link;
      fetchVideoFromApi(videoLink);
    } catch (error) {
      showError(error?.response?.data?.body?.message);
    }
  };

  const fetchVideoFromApi = async (data) => {
    try {
      const videoUrl = data; // API video URL
      const response = await fetch(videoUrl);
      const videoData = await response.blob();

      const vidoeId = loginData?.organization_id;
      const openRequest = indexedDB.open(vidoeId, 1);

      openRequest.onupgradeneeded = (event) => {
        const db = event.target.result;
        db.createObjectStore("videoChunks", { keyPath: "chunkNumber" });
      };

      openRequest.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction(["videoChunks"], "readwrite");
        const chunkStore = transaction.objectStore("videoChunks");

        const chunkSize = 5 * 1024 * 1024; // Chunk size (5MB in this example)
        let offset = 0;
        let chunkNumber = 0;

        const processNextChunk = () => {
          const end = Math.min(offset + chunkSize, videoData.size);
          const chunk = videoData.slice(offset, end);
          const chunkObject = {
            chunkNumber,
            data: chunk,
          };
          const request = chunkStore.add(chunkObject);

          request.onsuccess = () => {
            chunkNumber++;
            offset = end;

            if (offset < videoData.size) {
              processNextChunk();
            } else {
              console.log("Video saved to IndexedDB");
            }
          };
        };
        processNextChunk();
      };
    } catch (error) {
      console.error("Error fetching video:", error);
    }
  };

  const getRoleData = async () => {
    const id = {
      userid: loginData?.login_id,
    };
    const response = await roleData(id);
    const data = response.data.body;
    dispatch(setRoleData(data));
  };

  const checkOfflineRegister = () => {
    const storedData = sessionStorage.getItem("visitor");

    if (storedData) {
      let data = JSON.parse(storedData);

      // Check if data is not null or undefined before entering the loop
      if (data) {
        for (const key in data) {
          const visitor = data[key];
          if (!visitor.terms) {
            delete data[key];
          }
        }

        // Check if data is not empty before storing it back
        if (Object.keys(data).length > 0) {
          sessionStorage.setItem("visitor", JSON.stringify(data));
        } else {
          // If data is empty, you may choose to clear the sessionStorage
          sessionStorage.removeItem("visitor");
        }
      }
    }
  };

  const masterLabelData = async () => {
    if (loginData?.role_name !== "Admin") {
      const dataObj = {
        LanguageId: labelLanguageID,
        OrganizationId: loginData?.organization_id,
      };
      const masterLabel = await MasterLabelAPI(dataObj);
      const data = masterLabel?.data?.body?.data;
      dispatch(setMasterLabel(data));
    }
  };

  const FieldData = async () => {
    const obj = {
      userid: loginData?.login_id,
      organization_id: loginData?.organization_id,
      text_message: {
        language_id: labelLanguageID,
        organization_id: loginData?.organization_id,
      },
    };
    const response = await FieldTableAPI(obj);
    if (response?.data?.statusCode === 200) {
      const FieldData = response?.data?.body?.data;
      dispatch(setFieldData(FieldData));
    } else if (response?.data?.statusCode === 409) {
      showError(response?.data?.body?.message);
    }
  };

  // Checkin Refuse API
  const CheckInRefuseAPI = async () => {
    const idObj = {
      organization_id: loginData.organization_id,
    };

    const response = await checkInRefuse(idObj);
    dispatch(setVisitorId(null));
  };

  const checkouData = async () => {
    var search = {
      badgenumber: "",
      firstname: "",
      lastname: "",
      userid: loginData?.login_id,
      text_message: {
        language_id: labelLanguageID,
        organization_id: loginData?.organization_id,
      },
    };
    const response = await checkOutList(search);

    if (response?.data?.statusCode === 404) {
      dispatch(setUserDatails([]));
    } else if (response?.data?.statusCode === 200) {
      const userDetails = response?.data?.body;
      if (!userDetails || userDetails?.length === 0) {
      }
      dispatch(setUserDatails(userDetails));
    }
  };


  const fetchOrganizationFeatures = async () => {
    const dataObj = {
      userid: loginData?.login_id,
      organizationid: loginData?.organization_id,
      text_message: {
        language_id: labelLanguageID,
        organization_id: loginData?.organization_id,
      },
    };
    try {
      const response = await OrganizationFeaturesList(dataObj);
      if (response?.data?.statusCode === 200) {
        const data = response?.data?.body?.data;
        dispatch(setFeaturesList(data));
      } else {
        setFeaturesList([]);

      }
    } catch (error) {
      setFeaturesList([]);
      // Handle errors here
      console.error('Error fetching organization features:', error);
    }
  };

  const visitorLogData = async () => {
    var search = {
      category1: "All",
      category2: "All",
      category3: "All",
      visitor_type_id: "All",
      userid: loginData?.login_id,
      organizationid: loginData?.organization_id,
      text_message: {
        language_id: labelLanguageID,
        organization_id: loginData?.organization_id,
      },
    }
    const response = await CSOAPI(search);
    if (response?.data?.statusCode === 200) {
      const csoResult = response?.data?.body;
      dispatch(setCSOData(csoResult));
    }
    else {
      dispatch(setCSOData([]))
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          fetchOrganizationData(),
          getVistiorTypeHandler(),
          getLocationHandler(),
          getRoleData(),
          checkouData(),
          masterLabelData(),
          CheckInRefuseAPI(),
          FieldData(),
          visitorLogData(),
          fetchOrganizationFeatures(),
        ]);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        // fetchData();
      }
    };
    if (navigator.onLine) {
      fetchData();
      checkOfflineRegister();
    } else {
      setIsLoading(false);
      checkOfflineRegister();
    }
  }, [loginData?.organization_id, dispatch]);

  const handleClick = () => {
    navigate("/Formscreen");
  };

  const handleCheckOut = () => {
    navigate("/CheckoutScreen");
  };

  //* handle if user login not back without login
  useEffect(() => {
    // Add the event listener to the window
    window.addEventListener("popstate", handlePopstate);
  }, []);

  //* handler router
  const handlePopstate = (event) => {
    if (navigator.onLine) {
      if (!isNonEmptyString(loginData?.organization_id)) {
        // Navigate back
        navigate(-1);
      } else {
        // Prevent the default behavior of the Back button and stay on the current page
        event.preventDefault();
        navigate("/CheckInPage");
      }
    }
  };

  const handleWatchVideo = () => {
    navigate("/VideoScreen");
  }

  return (
    <Layout>
      <div className="card d-flex justify-content-center justify-content-center text-white p-3 col-xxl-5 col-xl-5 col-md-7 col-sm-10 col-xs-10 ">
        <div className=" d-flex justify-content-center">
          <img
            src={formLogo}
            height={65}
            width={371}
            className="checkin-logo"
            alt="logo"
          />
        </div>
        {isLoading ? (
          <div className="text-center">
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </div>
        ) : (
          <div className=" mt-4">
            <div className="row mb-4 gy-3 justify-content-center">
              <>
                {(isView("isCheckIn") || isCreate("isCheckIn")) && (
                  <div className="col-lg-5 col-md-8 col-sm-8 col-xs-8 ">
                    <button
                      className="btn btn-lg btn-primary w-100 "
                      onClick={handleClick}
                    >
                      <svg
                        width="19"
                        height="23"
                        viewBox="0 0 19 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="me-2"
                      >
                        <path
                          d="M4.19922 6.1969C4.19922 6.74918 4.64693 7.1969 5.19922 7.1969C5.7515 7.1969 6.19922 6.74918 6.19922 6.1969H4.19922ZM6.19922 16.1969C6.19922 15.6446 5.7515 15.1969 5.19922 15.1969C4.64693 15.1969 4.19922 15.6446 4.19922 16.1969H6.19922ZM6.29124 20.9789L6.74523 20.0879L6.74523 20.0879L6.29124 20.9789ZM5.41721 20.1049L4.5262 20.5589H4.5262L5.41721 20.1049ZM16.9812 20.1049L17.8722 20.5589L16.9812 20.1049ZM16.1072 20.9789L15.6532 20.0879L15.6532 20.0879L16.1072 20.9789ZM16.1072 1.41489L15.6532 2.30589L15.6532 2.30589L16.1072 1.41489ZM16.9812 2.28892L16.0902 2.74291V2.74291L16.9812 2.28892ZM5.41721 2.28892L4.5262 1.83493V1.83493L5.41721 2.28892ZM6.29124 1.41489L5.83725 0.52388V0.52388L6.29124 1.41489ZM12.1992 12.1969C12.7515 12.1969 13.1992 11.7492 13.1992 11.1969C13.1992 10.6446 12.7515 10.1969 12.1992 10.1969V12.1969ZM1.19922 10.1969C0.646934 10.1969 0.199219 10.6446 0.199219 11.1969C0.199219 11.7492 0.646934 12.1969 1.19922 12.1969L1.19922 10.1969ZM9.49211 13.4898C9.10159 13.8803 9.10159 14.5135 9.49211 14.904C9.88264 15.2945 10.5158 15.2945 10.9063 14.904L9.49211 13.4898ZM12.0678 12.3283L12.775 13.0354L12.0678 12.3283ZM12.0678 10.0655L12.775 9.35843L12.775 9.35842L12.0678 10.0655ZM10.9063 7.48979C10.5158 7.09927 9.88264 7.09927 9.49211 7.48979C9.10159 7.88032 9.10159 8.51348 9.49211 8.90401L10.9063 7.48979ZM12.7361 11.5059L11.785 11.1969L12.7361 11.5059ZM12.7361 10.8879L11.785 11.1969L12.7361 10.8879ZM6.19922 6.1969V4.3969H4.19922V6.1969H6.19922ZM8.39922 2.1969H13.9992V0.196899H8.39922V2.1969ZM16.1992 4.3969V17.9969H18.1992V4.3969H16.1992ZM13.9992 20.1969H8.39922V22.1969H13.9992V20.1969ZM6.19922 17.9969V16.1969H4.19922V17.9969H6.19922ZM8.39922 20.1969C7.82267 20.1969 7.45039 20.1961 7.16705 20.173C6.89539 20.1508 6.79467 20.1131 6.74523 20.0879L5.83725 21.8699C6.21563 22.0627 6.60885 22.134 7.00419 22.1663C7.38786 22.1977 7.85567 22.1969 8.39922 22.1969V20.1969ZM4.19922 17.9969C4.19922 18.5405 4.19844 19.0083 4.22979 19.3919C4.26209 19.7873 4.33341 20.1805 4.5262 20.5589L6.30821 19.6509C6.28302 19.6014 6.24534 19.5007 6.22315 19.2291C6.2 18.9457 6.19922 18.5735 6.19922 17.9969H4.19922ZM6.74523 20.0879C6.55707 19.992 6.40409 19.8391 6.30821 19.6509L4.5262 20.5589C4.81382 21.1234 5.27276 21.5823 5.83725 21.8699L6.74523 20.0879ZM16.1992 17.9969C16.1992 18.5735 16.1984 18.9457 16.1753 19.2291C16.1531 19.5007 16.1154 19.6014 16.0902 19.6509L17.8722 20.5589C18.065 20.1805 18.1363 19.7873 18.1686 19.3919C18.2 19.0083 18.1992 18.5405 18.1992 17.9969H16.1992ZM13.9992 22.1969C14.5428 22.1969 15.0106 22.1977 15.3942 22.1663C15.7896 22.134 16.1828 22.0627 16.5612 21.8699L15.6532 20.0879C15.6038 20.1131 15.503 20.1508 15.2314 20.173C14.948 20.1961 14.5758 20.1969 13.9992 20.1969V22.1969ZM16.0902 19.6509C15.9944 19.8391 15.8414 19.992 15.6532 20.0879L16.5612 21.8699C17.1257 21.5823 17.5846 21.1234 17.8722 20.5589L16.0902 19.6509ZM13.9992 2.1969C14.5758 2.1969 14.948 2.19768 15.2314 2.22083C15.503 2.24302 15.6038 2.2807 15.6532 2.30589L16.5612 0.52388C16.1828 0.331086 15.7896 0.25977 15.3942 0.227469C15.0106 0.196122 14.5428 0.196899 13.9992 0.196899V2.1969ZM18.1992 4.3969C18.1992 3.85335 18.2 3.38554 18.1686 3.00187C18.1363 2.60653 18.065 2.21331 17.8722 1.83493L16.0902 2.74291C16.1154 2.79235 16.1531 2.89307 16.1753 3.16474C16.1984 3.44807 16.1992 3.82035 16.1992 4.3969H18.1992ZM15.6532 2.30589C15.8414 2.40177 15.9944 2.55475 16.0902 2.74291L17.8722 1.83493C17.5846 1.27044 17.1257 0.8115 16.5612 0.52388L15.6532 2.30589ZM6.19922 4.3969C6.19922 3.82035 6.2 3.44807 6.22315 3.16474C6.24534 2.89307 6.28302 2.79235 6.30821 2.74291L4.5262 1.83493C4.33341 2.21331 4.26209 2.60653 4.22979 3.00187C4.19844 3.38554 4.19922 3.85335 4.19922 4.3969H6.19922ZM8.39922 0.196899C7.85567 0.196899 7.38786 0.196122 7.00419 0.227469C6.60885 0.25977 6.21563 0.331086 5.83725 0.52388L6.74523 2.30589C6.79467 2.2807 6.89539 2.24302 7.16705 2.22083C7.45039 2.19768 7.82267 2.1969 8.39922 2.1969V0.196899ZM6.30821 2.74291C6.40409 2.55475 6.55707 2.40177 6.74523 2.30589L5.83725 0.52388C5.27276 0.8115 4.81382 1.27044 4.5262 1.83493L6.30821 2.74291ZM12.1992 10.1969L1.19922 10.1969L1.19922 12.1969L12.1992 12.1969V10.1969ZM10.9063 14.904L12.775 13.0354L11.3607 11.6212L9.49211 13.4898L10.9063 14.904ZM12.775 9.35842L10.9063 7.48979L9.49211 8.90401L11.3607 10.7726L12.775 9.35842ZM12.775 13.0354C12.9613 12.849 13.1441 12.6673 13.285 12.5014C13.4334 12.3265 13.593 12.1047 13.6871 11.8149L11.785 11.1969C11.8049 11.1355 11.8284 11.1268 11.7603 11.207C11.6846 11.2962 11.5704 11.4115 11.3607 11.6212L12.775 13.0354ZM11.3607 10.7726C11.5704 10.9823 11.6846 11.0976 11.7603 11.1868C11.8284 11.267 11.805 11.2583 11.785 11.1969L13.6871 10.5789C13.593 10.2891 13.4334 10.0673 13.285 9.89241C13.1441 9.72649 12.9613 9.54476 12.775 9.35843L11.3607 10.7726ZM13.6871 11.8149C13.8176 11.4132 13.8176 10.9806 13.6871 10.5789L11.785 11.1969V11.1969L13.6871 11.8149Z"
                          fill="black"
                        />
                      </svg>
                      {findDisplayName("dashboardCheckInButton", "Check-in")}
                    </button>
                  </div>
                )}
                {isView("isCheckOut") && (
                  <div className="col-lg-5 col-md-8 col-sm-8 col-xs-8">
                    <button
                      className="btn btn-primary btn-lg w-100 me-4"
                      onClick={handleCheckOut}
                    >
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="me-2"
                      >
                        <path
                          d="M17.8002 17.1969C17.8002 16.6446 17.3525 16.1969 16.8002 16.1969C16.2479 16.1969 15.8002 16.6446 15.8002 17.1969L17.8002 17.1969ZM15.8002 7.1969C15.8002 7.74918 16.2479 8.1969 16.8002 8.1969C17.3525 8.1969 17.8002 7.74918 17.8002 7.1969L15.8002 7.1969ZM15.7082 2.41489L15.2542 3.30589L15.2542 3.30589L15.7082 2.41489ZM16.5822 3.28892L17.4732 2.83493L17.4732 2.83493L16.5822 3.28892ZM5.01819 3.28892L4.12718 2.83493L5.01819 3.28892ZM5.89222 2.41489L6.34621 3.30589L6.34621 3.30589L5.89222 2.41489ZM5.89222 21.9789L6.34621 21.0879L6.34621 21.0879L5.89222 21.9789ZM5.01819 21.1049L5.9092 20.6509L5.9092 20.6509L5.01819 21.1049ZM16.5822 21.1049L17.4732 21.5589L17.4732 21.5589L16.5822 21.1049ZM15.7082 21.9789L16.1622 22.8699L16.1622 22.8699L15.7082 21.9789ZM21.8002 13.1969C22.3525 13.1969 22.8002 12.7492 22.8002 12.1969C22.8002 11.6446 22.3525 11.1969 21.8002 11.1969L21.8002 13.1969ZM10.8002 11.1969C10.2479 11.1969 9.8002 11.6446 9.8002 12.1969C9.8002 12.7492 10.2479 13.1969 10.8002 13.1969L10.8002 11.1969ZM19.0931 14.4898C18.7026 14.8803 18.7026 15.5135 19.0931 15.904C19.4836 16.2945 20.1168 16.2945 20.5073 15.904L19.0931 14.4898ZM21.6688 13.3283L22.3759 14.0354L22.3759 14.0354L21.6688 13.3283ZM21.6688 11.0655L22.3759 10.3584L22.3759 10.3584L21.6688 11.0655ZM20.5073 8.48979C20.1168 8.09927 19.4836 8.09927 19.0931 8.48979C18.7026 8.88032 18.7026 9.51348 19.0931 9.904L20.5073 8.48979ZM22.337 12.5059L21.386 12.1969L22.337 12.5059ZM22.337 11.8879L21.386 12.1969L22.337 11.8879ZM15.8002 17.1969L15.8002 18.9969L17.8002 18.9969L17.8002 17.1969L15.8002 17.1969ZM13.6002 21.1969L8.0002 21.1969L8.0002 23.1969L13.6002 23.1969L13.6002 21.1969ZM5.8002 18.9969L5.8002 5.3969L3.8002 5.3969L3.8002 18.9969L5.8002 18.9969ZM8.0002 3.1969L13.6002 3.1969L13.6002 1.1969L8.0002 1.1969L8.0002 3.1969ZM15.8002 5.3969L15.8002 7.1969L17.8002 7.1969L17.8002 5.3969L15.8002 5.3969ZM13.6002 3.1969C14.1768 3.1969 14.549 3.19768 14.8324 3.22083C15.104 3.24302 15.2047 3.2807 15.2542 3.30589L16.1622 1.52388C15.7838 1.33108 15.3906 1.25977 14.9952 1.22747C14.6116 1.19612 14.1438 1.1969 13.6002 1.1969L13.6002 3.1969ZM17.8002 5.3969C17.8002 4.85335 17.801 4.38554 17.7696 4.00187C17.7373 3.60653 17.666 3.21331 17.4732 2.83493L15.6912 3.74291C15.7164 3.79235 15.7541 3.89307 15.7763 4.16474C15.7994 4.44807 15.8002 4.82035 15.8002 5.3969L17.8002 5.3969ZM15.2542 3.30589C15.4424 3.40177 15.5953 3.55475 15.6912 3.74291L17.4732 2.83493C17.1856 2.27044 16.7267 1.8115 16.1622 1.52388L15.2542 3.30589ZM5.8002 5.3969C5.8002 4.82035 5.80098 4.44807 5.82413 4.16473C5.84633 3.89307 5.884 3.79235 5.9092 3.74291L4.12718 2.83493C3.93439 3.2133 3.86307 3.60652 3.83077 4.00187C3.79942 4.38554 3.8002 4.85335 3.8002 5.3969L5.8002 5.3969ZM8.0002 1.1969C7.45665 1.1969 6.98885 1.19612 6.60518 1.22747C6.20983 1.25977 5.81661 1.33108 5.43823 1.52388L6.34621 3.30589C6.39566 3.2807 6.49638 3.24302 6.76804 3.22083C7.05138 3.19768 7.42365 3.1969 8.0002 3.1969L8.0002 1.1969ZM5.9092 3.74291C6.00507 3.55475 6.15805 3.40176 6.34621 3.30589L5.43823 1.52388C4.87375 1.8115 4.4148 2.27044 4.12718 2.83493L5.9092 3.74291ZM8.0002 21.1969C7.42365 21.1969 7.05137 21.1961 6.76804 21.173C6.49638 21.1508 6.39566 21.1131 6.34621 21.0879L5.43823 22.8699C5.81661 23.0627 6.20983 23.134 6.60517 23.1663C6.98884 23.1977 7.45665 23.1969 8.0002 23.1969L8.0002 21.1969ZM3.8002 18.9969C3.8002 19.5404 3.79942 20.0083 3.83077 20.3919C3.86307 20.7873 3.93439 21.1805 4.12718 21.5589L5.9092 20.6509C5.884 20.6014 5.84633 20.5007 5.82413 20.2291C5.80098 19.9457 5.8002 19.5735 5.8002 18.9969L3.8002 18.9969ZM6.34621 21.0879C6.15805 20.992 6.00507 20.839 5.9092 20.6509L4.12718 21.5589C4.4148 22.1234 4.87374 22.5823 5.43823 22.8699L6.34621 21.0879ZM15.8002 18.9969C15.8002 19.5735 15.7994 19.9457 15.7763 20.2291C15.7541 20.5007 15.7164 20.6014 15.6912 20.6509L17.4732 21.5589C17.666 21.1805 17.7373 20.7873 17.7696 20.3919C17.801 20.0083 17.8002 19.5405 17.8002 18.9969L15.8002 18.9969ZM13.6002 23.1969C14.1438 23.1969 14.6116 23.1977 14.9952 23.1663C15.3906 23.134 15.7838 23.0627 16.1622 22.8699L15.2542 21.0879C15.2047 21.1131 15.104 21.1508 14.8324 21.173C14.549 21.1961 14.1768 21.1969 13.6002 21.1969L13.6002 23.1969ZM15.6912 20.6509C15.5953 20.8391 15.4424 20.992 15.2542 21.0879L16.1622 22.8699C16.7267 22.5823 17.1856 22.1234 17.4732 21.5589L15.6912 20.6509ZM21.8002 11.1969L10.8002 11.1969L10.8002 13.1969L21.8002 13.1969L21.8002 11.1969ZM20.5073 15.904L22.3759 14.0354L20.9617 12.6212L19.0931 14.4898L20.5073 15.904ZM22.3759 10.3584L20.5073 8.48979L19.0931 9.904L20.9617 11.7726L22.3759 10.3584ZM22.3759 14.0354C22.5623 13.849 22.7451 13.6673 22.886 13.5014C23.0344 13.3265 23.194 13.1047 23.2881 12.8149L21.386 12.1969C21.4059 12.1355 21.4294 12.1268 21.3613 12.207C21.2856 12.2962 21.1714 12.4115 20.9617 12.6212L22.3759 14.0354ZM20.9617 11.7726C21.1714 11.9823 21.2856 12.0976 21.3613 12.1868C21.4294 12.267 21.4059 12.2583 21.386 12.1969L23.2881 11.5789C23.194 11.2891 23.0344 11.0673 22.886 10.8924C22.7451 10.7265 22.5623 10.5448 22.3759 10.3584L20.9617 11.7726ZM23.2881 12.8149C23.4186 12.4132 23.4186 11.9806 23.2881 11.5789L21.386 12.1969L21.386 12.1969L23.2881 12.8149Z"
                          fill="black"
                        />
                      </svg>
                      {findDisplayName("dashboardCheckOutButton", "Check-Out")}
                    </button>
                  </div>
                )}
                {
                  isBatchView("isWatchVideo") && (
                    <div className="col-lg-10 col-md-8 col-sm-8 col-xs-8 ">
                      <button
                        className="btn btn-lg btn-dark w-100 " style={{ fontSize: '18px' }}
                        onClick={handleWatchVideo}
                      >
                        <FaCirclePlay className="me-2" style={{ width: '23px', height: '23px' }} />
                        {findDisplayName("dashboardWatchVideoButton", "Watch video")}
                      </button>
                    </div>
                  )
                }
              </>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};
